import { FC } from "react";
import { Helmet } from "react-helmet";

interface SeoHeadProps {
  title: string;
  description: string;
  keywords?: string;
  url?: string;
}

export const SeoHead: FC<SeoHeadProps> = ({
  title,
  description,
  keywords,
  url,
}) => (
  <Helmet>
    <title>{title}</title>
    <meta name="description" content={description} />
    <meta name="keywords" content={keywords} />
    <meta property="og:title" content={title} />
    <meta property="og:description" content={description} />
    <meta property="og:type" content="website" />
    {url && <link rel="canonical" href={url} />}
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content={title} />
    <meta name="twitter:description" content={description} />

    <script type="application/ld+json">
      {JSON.stringify({
        "@context": "https://schema.org",
        "@type": "WebPage",
        name: title,
        description: description,
        url: url,
        fees: "Low transaction fees",
        currenciesAccepted: "Cryptocurrency",
        serviceType: "Crypto bridge & swap",
      })}
    </script>
  </Helmet>
);
